// src/assets/icons/index.js
import bookmarkIcon from "src/assets/icons/bookmark-02-20px.svg";
import alertIcon from "src/assets/icons/alert-02.svg";
import alertc from "src/assets/icons/alertc.svg";
import arrowDownIcon from "src/assets/icons/arrow-down-01.svg";
import arrowLeftIcon from "src/assets/icons/arrow-left-01.svg";
import calendarIcon from "src/assets/icons/calendar-minus-02.svg";
import checkmarkCircleIcon from "src/assets/icons/checkmark-circle-04.svg";
import shareIcon from "src/assets/icons/share-08.svg";
import newsIcon from "src/assets/icons/news-01.svg";
import veille from "src/assets/icons/sticky-note-01.svg";
import mailIcon from "src/assets/icons/mail-open.svg";
import messageIcon from "src/assets/icons/text-square.svg";
import notifIcon from "src/assets/icons/notification-03.svg";
import notifs from "src/assets/icons/notifs.svg";
import defaultMedicineImage from "src/assets/icons/medicine.svg";
import expertIcon from "src/assets/icons/laurel-wreath-01.svg";
import institutions from "src/assets/icons/court-house.svg";
import formation from "src/assets/icons/playlist-01.svg";
import agenda from "src/assets/icons/calendar-03.svg";
import menuSquare from "src/assets/icons/menu-square.svg";
import AIhelp from "src/assets/icons/help.svg";
import NanoTech from "src/assets/icons/nanotechnology.svg";
import Pill from "src/assets/icons/pill.svg";
import alert02 from "src/assets/icons/alert-02.svg";
import avis from "src/assets/icons/avis.svg";
import medicaments from "src//assets/icons/medicine-02.svg";
import diseases from "src//assets/icons/diseases.svg";

export const icons = {
  diseases: diseases,
  medicaments:medicaments,
  avis:avis,
  alert02: alert02,
  bookmark: bookmarkIcon,
  alert: alertIcon,
  alertc: alertc,
  arrowDown: arrowDownIcon,
  arrowLeft: arrowLeftIcon,
  calendar: calendarIcon,
  checkmark: checkmarkCircleIcon,
  share: shareIcon,
  message: messageIcon,
  news: newsIcon,
  mail: mailIcon,
  notif: notifIcon,
  notifs: notifs,
  defaultMedicineImage: defaultMedicineImage,
  expert: expertIcon,
  institutions: institutions,
  formation: formation,
  agenda: agenda,
  menuSquare: menuSquare,
  AIhelp: AIhelp,
  NanoTech: NanoTech,
  veille: veille,
  Pill: Pill,
};

export default icons;
